var React = require('react');

function FlagNL (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1.379","fill":"#AE1C28","width":"897.56","height":"200","key":0}),React.createElement("rect",{"x":"1.379","y":"399.75","fill":"#21468B","width":"897.56","height":"200","key":1})]);
}

FlagNL.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"900px","height":"600px","viewBox":"0 0 900 600","enableBackground":"new 0 0 900 600","xmlSpace":"preserve"};

module.exports = FlagNL;

FlagNL.default = FlagNL;
